import React from 'react';
import './EventLink.css';

export interface Props {
  title: string;
}

export const EventLink = (props: Props) => {
  const { title } = props;

  return <p className="event-link">{title}</p>;
};
